import { useRouteError, useNavigate } from "react-router-dom";
import ErrorDisplay from "./ErrorDisplay";

export default function ErrorElement() {
  const error = useRouteError();
  const navigate = useNavigate();

  const handleGoHome = () => {
    navigate("/");
  };

  const handleRefresh = () => {
    window.location.reload();
  };

  return (
    <ErrorDisplay
      error={error}
      onGoHome={handleGoHome}
      onRefresh={handleRefresh}
    />
  );
}
